"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Props_1 = require("../../shared/Props");
const Responsive_1 = require("../../shared/Responsive");
const getSize = ({ $size = "medium" }) => {
    const mappingCss = {
        xsmall: {
            width: "var(--ds-icon-size, 1.25rem)",
        },
        small: {
            width: "var(--ds-icon-size, 1.5rem)",
        },
        medium: {
            width: "var(--ds-icon-size, 2rem)",
        },
        large: {
            width: "var(--ds-icon-size, 2.5rem)",
        },
        xlarge: {
            width: "var(--ds-icon-size, 3rem)",
        },
    };
    return (0, Responsive_1.responsiveMapToMedia)($size, mappingCss);
};
const getDegreesRotation = ({ $rotate }) => {
    // Using negative values to avoid doing a full circle animation going from 270deg to 0deg
    switch ($rotate) {
        case "270":
            return "90deg";
        case "180":
            return "-180deg";
        case "90":
            return "-90deg";
        case "0":
        default:
            return "0deg";
    }
};
const getColor = ({ $color = "zinc" }) => {
    if ($color === "currentColor") {
        return "currentColor";
    }
    if ((0, Props_1.isGreyscaleColor)($color)) {
        return `var(--ds-color-${$color})`;
    }
    return `var(--ds-color-${$color}-100)`;
};
exports.StyledIcon = styled_components_1.default.svg `
    /** Fix spacing https://stackoverflow.com/a/24626986/3224333 */
    vertical-align: top;

    /** dimension */
    ${getSize}
    aspect-ratio: 1 / 1;

    /** color */
    fill: var(--ds-icon-color, ${getColor});

    /* rotation */
    transition: transform 200ms ease-in-out;
    transform: rotate(${getDegreesRotation});
`;
//# sourceMappingURL=Icon.styles.js.map